import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { GhiseuModuleService } from '../ghiseu-module.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { Modul } from '../ghiseu-module.interface';

@Component({
    selector: 'app-add-ghiseu-module',
    templateUrl: './add-ghiseu-module.component.html',
    styleUrls: ['./add-ghiseu-module.component.scss']
})
export class AddGhiseuModuleComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', Validators.required),
        slug: new FormControl('', Validators.required),
        max_programari_per_day: new FormControl(null),
    });

    constructor(
        private dialogRef: MatDialogRef<AddGhiseuModuleComponent>,
        private ghiseuModuleService: GhiseuModuleService,
        private notificationService: NotificationService,
        private authService: AuthService,
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.ghiseuModuleService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, max_programari_per_day } = this.form.value as Modul;

        const newModul: Modul = {
            name,
            slug,
            max_programari_per_day: max_programari_per_day || null,
        };

        this.ghiseuModuleService
            .addModul(newModul)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
